import meiliSearchApiClient from 'src/api/clients/meilisearch';
import tenantApi from 'src/api/clients/tenant';
import { SearchState } from 'src/hooks/meilisearch/types/search-state';
import { MeiliSearchResponse } from 'src/types/responses/meilisearch';
import { calculatePaginationOffset } from 'src/utils/calculate-pagination-offset';
import { CreateEmployeesGroupResponse } from '../types/response/create-employees-group.response';
import { EmployeeGroupResponse } from '../types/response/employee-group.response';

export const fetchEmployeesGroups = async (
  tenantToken: string,
  searchState: SearchState,
  page: number,
  perPage: number,
) => {
  const { data } = await meiliSearchApiClient.post<
    MeiliSearchResponse<EmployeeGroupResponse>
  >(`/indexes/EmployeeGroup-${tenantToken}/search`, {
    ...searchState,
    limit: perPage,
    offset: calculatePaginationOffset(page, perPage),
  });

  return data;
};

export const createEmployeesGroup = async (
  name: string,
  employeesTokens: string[],
): Promise<CreateEmployeesGroupResponse> => {
  const { data } = await tenantApi.post<CreateEmployeesGroupResponse>(
    '/employee-groups',
    {
      name,
      employeesTokens,
    },
  );

  return data;
};

export const updateEmployeesGroupDefault = async (
  employeeGroupToken: string,
  isDefault: boolean,
): Promise<void> => {
  await tenantApi.patch<void>(
    `/employee-groups/${employeeGroupToken}/${isDefault}`,
  );
};
